import { sdkInstance } from './Instance';
import { IApp } from 'matrix-requirements-sdk/client';

function logPerformance() {
  let perf = window.performance;
  if (perf === undefined) {
    console.log('Performance API is not supported');
    return;
  }
  let toLog: any = {};
  let navPerf = perf.getEntriesByType('navigation');
  if (navPerf.length > 0) {
    let navigationTime = navPerf[0] as PerformanceNavigationTiming;
    toLog.url = window.location.href;
    toLog.redirectCount = navigationTime.redirectCount;
    toLog.navigationType = navigationTime.type;
    toLog.navigationStart = parseFloat(navigationTime.startTime.toFixed(2));
    toLog.msDOMLoaded = parseFloat(
      (
        navigationTime.domContentLoadedEventEnd - navigationTime.startTime
      ).toFixed(2),
    );
    toLog.msPageFullyLoaded = parseFloat(
      (navigationTime.loadEventEnd - navigationTime.startTime).toFixed(2),
    );

    toLog.msServerResponseReceived = parseFloat(
      (navigationTime.responseEnd - navigationTime.startTime).toFixed(2),
    );
  }
  let resources = perf.getEntriesByType('resource');
  toLog.resources = [];
  for (let r of resources) {
    let resource = r as PerformanceResourceTiming;
    toLog.resources.push({
      name: resource.name,
      msDuration: parseFloat(resource.duration.toFixed(2)),
      initiatorType: resource.initiatorType,
      msStartTimeSinceNavigationStart: parseFloat(
        resource.startTime.toFixed(2),
      ),
      kbDecodedBodySize: parseFloat(
        (resource.decodedBodySize / 1024).toFixed(2),
      ),
    });
  }

  (<any>window).core.restConnection.postServer('all/log', {
    message: 'perf-measurement ' + JSON.stringify(toLog),
  });
}

if (sdkInstance.app === undefined) {
  // This is liveQMS
  if (window.location.href.indexOf('login?dest-url') == -1) {
    setTimeout(logPerformance, 5000);
  }
  //Nothing to do when login screen is there.
} else if (sdkInstance.app.isConfigApp()) {
  // Let start it in 5 seconds;
  setTimeout(logPerformance, 5000);
} else {
  (<IApp>sdkInstance.app).waitForMainTree(logPerformance);
}
